<template>
  <core-sidebar
    @hidden="handleHideEvent"
    @change.once="getStateFilterApi"
    sidebar-class="w-100 w-lg-25"
    id="jobs-filter"
    header-class="bg-portal-primary p-3"
    body-class="px-3 pt-3 d-flex flex-column"
    shadow
    backdrop
    no-close-on-route-change
  >
    <template #header="{ hide }">
      <b-row align-v="center" class="flex-grow-1">
        <b-col class="d-flex">
          <span class="fs-5 fw-bolder text-white">
            <b-icon icon="sliders" class="mr-2"></b-icon>
            {{ translations[13590] }}
          </span>
        </b-col>
        <b-col cols="auto" class="d-flex ml-auto">
          <b-button class="bg-transparent border-0 p-1" @click="hide()">
            <b-icon icon="x" font-scale="1.5"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template #default="{ hide }">
      <h5 class="font-weight-light mb-3">{{ translations[13586] }}</h5>
      <!-- DON'T REMOVE IT -->
<!--      <b-tabs nav-class="mb-0 fs-6 d-flex w-100" no-nav-style>-->
<!--        <b-tab active title-item-class="flex-fill h6" title-link-class="text-black px-0 py-1 fw-normal">-->
<!--          <template #title>-->
<!--            {{ translations[13422] }}-->
<!--            <span v-b-tooltip.hover :title="translations[13601]" class="ml-2">-->
<!--              <b-icon icon="info-circle" class="text-black-50" scale="0.8"></b-icon>-->
<!--            </span>-->
<!--          </template>-->
<!--          <div class="mb-3">-->
<!--            &lt;!&ndash;            <select-profession v-model="selectProfession" :placeholder="translations[13602]" />&ndash;&gt;-->
<!--            <select-profession-update :similar-professions="true" v-model="selectProfession" :sm="true" :placeholder="translations[13602]" @change="[search(), getEmploymentCountApi()]" />-->
<!--          </div>-->
<!--        </b-tab>-->
<!--        <b-tab title-item-class="flex-fill h6" title-link-class="text-black px-0 py-1 fw-normal">-->
<!--          <template #title>-->
<!--            {{ translations[13633] }}-->
<!--            <span v-b-tooltip.hover :title="translations[13634]" class="ml-2">-->
<!--              <b-icon icon="info-circle" class="text-black-50" scale="0.8"></b-icon>-->
<!--            </span>-->
<!--          </template>-->
<!--          <div class="mb-3">-->
<!--            <b-form-checkbox-group @change="[search(), getEmploymentCountApi()]" v-model="cluster" size="sm" switches stacked :options="clusters" value-field="id" text-field="name" />-->
<!--          </div>-->
<!--        </b-tab>-->
<!--      </b-tabs>-->
      <!-- DON'T REMOVE IT -->
      <!-- update 19.07.2024-->
      <div class="mb-3">
        <b-form-checkbox @change="search" size="sm" v-model="emailStatus" switch>
          {{ translations[11498] }}
        </b-form-checkbox>
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[13633]" :tooltip-text="translations[13634]" />
        <b-form-checkbox-group @change="[search(), getEmploymentCountApi()]" v-model="cluster" size="sm" switches stacked :options="clusters" value-field="id" text-field="name" />
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[13422]" :tooltip-text="translations[13601]" />
        <select-profession-update :similar-professions="true" v-model="selectProfession" :sm="true" :placeholder="translations[13602]" @change="[search(), getEmploymentCountApi()]" />
      </div>
      <!-- update 19.07.2024-->
      <div class="mb-3">
        <filter-section-title :title-text="translations[13603]" :tooltip-text="translations[13604]" />
        <select-location-radius v-if="isCurses" :radius.sync="radius" v-model="selectLocation" @change="[search(), getEmploymentCountApi()]" :placeholder="translations[13605]" />
        <select-location v-else v-model="selectLocation" @change="[search(), getEmploymentCountApi()]" :placeholder="translations[13605]" />
      </div>
      <div v-if="isFederalStateFilterVisible" class="mb-3">
        <filter-section-title :title-text="translations[13606]" :tooltip-text="translations[13607]" />
        <multiselect
          v-if="federalStateItems"
          class="multiselect-sm"
          label="location_name"
          track-by="id"
          v-model="selectedState"
          :options="federalStateItems"
          :placeholder="translations[13237]"
          :multiple="true"
          :internal-search="false"
          :clear-on-select="false"
          :close-on-select="false"
          :options-limit="300"
          open-direction="bottom"
          :showNoOptions="false"
          selectLabel=""
          selectGroupLabel=""
          deselectLabel=""
          deselectGroupLabel=""
          :showLabels="false"
          @remove="[search(), getEmploymentCountApi()]"
          @select="[search(), getEmploymentCountApi()]"
        >
          <template slot="noResult">
            <b>{{ translations[9506] }}</b>
          </template>
        </multiselect>
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[609]" :tooltip-text="translations[13617]" />
        <b-form-input @blur="[search(), getEmploymentCountApi()]" v-model="searchText" size="sm" :placeholder="translations[13724]" class="mb-2"></b-form-input>
        <b-form-select @change="[search(), getEmploymentCountApi()]" v-model="searchTextType" :options="searchTextTypeOptions" size="sm"></b-form-select>
      </div>
      <template v-if="sid !== 'kle' && sid !== 'bbg'">
        <div class="mb-3">
          <filter-section-title :title-text="translations[13618]" :tooltip-text="translations[13619]" />
          <b-form-checkbox @change="search" size="sm" v-model="checkboxFullTime" switch>
            {{ translations[13620] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.fulltime) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxPartTime" switch>
            {{ translations[13621] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.parttime) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxPractice" switch>
            {{ translations[3843] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.edujob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox v-if="isJnjts" @change="search" size="sm" v-model="checkboxPraktikum" switch>
            {{ translations[10145] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.praktikum) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
        </div>
        <div v-if="isLocationCountryFilter" class="mb-3">
          <filter-section-title :title-text="translations[10124]" />
          <location-country-filter :loading-location-count="loadingLocationCount" @search="search" />
        </div>
        <div class="mb-4">
          <filter-section-title :title-text="translations[12150]" :tooltip-text="translations[13623]">
  <!--          <template v-if="!isAuth">-->
  <!--            <span v-b-tooltip.hover :title="translations[13624]" class="ml-2">-->
  <!--              <b-icon class="text-black-50" icon="shield-lock" />-->
  <!--            </span>-->
  <!--          </template>-->
          </filter-section-title>
  <!--        :disabled="!isAuth" v-b-modal="!isAuth ? 'not-auth-modal' : ''"-->
          <b-form-checkbox @change="search" size="sm" v-model="checkboxSkillLevel2" switch>
            {{ translations[13625] }}
            (<span v-if="!loadingSkillCount">{{ localeString(employmentCount.skill_level2) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
  <!--        :disabled="!isAuth" v-b-modal="!isAuth ? 'not-auth-modal' : ''"-->
          <b-form-checkbox @change="search" size="sm" v-model="checkboxSkillLevel3" switch>
            {{ translations[13626] }}
            (<span v-if="!loadingSkillCount">{{ localeString(employmentCount.skill_level3) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
        </div>
      </template>
      <!-- Нові фільтри (без кількості): Stellenherkunft, Umfang der Beschäftigung, Arbeitgeberart -->
      <template v-else>
        <div class="mb-3">
          <filter-section-title :title-text="translations[15917]" />

          <b-form-checkbox @change="search" size="sm" v-model="checkboxFullTime" switch>
            {{ translations[13620] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.fulltime) }}</span
          ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxPartTime" switch>
            {{ translations[13621] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.parttime) }}</span
          ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxMinijob" switch>
            {{ translations[10149] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.minijob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>

          <b-form-checkbox @change="search" size="sm" v-model="checkboxPractice" switch>
            {{ translations[10144] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.edujob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxPraktikum" switch>
            {{ translations[10145] }}
            (<span v-if="!loadingEmploymentCount">{{ localeString(employmentCount.praktikum) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
        </div>
        <div class="mb-3">
          <filter-section-title :title-text="translations[12150]" :tooltip-text="translations[13623]" />
          <b-form-checkbox @change="search" size="sm" v-model="checkboxSkillLevel1" switch>
            {{ translations[3856] }}
            (<span v-if="!loadingSkillCount">{{ localeString(employmentCount.skill_level1) }}</span
          ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxSkillLevel2" switch>
            {{ translations[4741] }}
            (<span v-if="!loadingSkillCount">{{ localeString(employmentCount.skill_level2) }}</span
          ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxSkillLevel3" switch>
            {{ translations[4742] }}
            (<span v-if="!loadingSkillCount">{{ localeString(employmentCount.skill_level3) }}</span
          ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
        </div>

        <div class="mb-3">
          <filter-section-title :title-text="translations[10124]" />
          <b-form-checkbox @change="search" size="sm" v-model="checkboxAmsjob" switch>
            {{ translations[10127] }}
            (<span v-if="!loadingStellenherkunftCount">{{ localeString(employmentCount.amsjob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
<!--          <b-form-checkbox @change="search" size="sm" v-model="checkboxPartnerJobsOnly" switch>-->
<!--            {{ translations[11260] }}-->
<!--            (<span v-if="!loadingStellenherkunftCount">{{ localeString(employmentCount.partner_jobs_only) }}</span-->
<!--            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)-->
<!--          </b-form-checkbox>-->
          <b-form-checkbox @change="search" size="sm" v-model="checkboxOtherJobs" switch>
            {{ translations[12690] }}
            (<span v-if="!loadingStellenherkunftCount">{{ localeString(employmentCount.other_jobs) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <location-country-filter :loading-location-count="loadingLocationCount" @search="search" />
        </div>

        <div class="mb-3">
          <filter-section-title :title-text="translations[10138]" />
          <b-form-checkbox @change="search" size="sm" v-model="checkboxDejob" switch>
            {{ translations[10422] }}
            (<span v-if="!loadingArbeitgeberartCount">{{ localeString(employmentCount.dejob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxRecruit" switch>
            {{ translations[10553] }} {{ translations[10554] }}
            (<span v-if="!loadingArbeitgeberartCount">{{ localeString(employmentCount.recruit) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
          <b-form-checkbox @change="search" size="sm" v-model="checkboxTmpjob" switch>
            {{ translations[10141] }}
            (<span v-if="!loadingArbeitgeberartCount">{{ localeString(employmentCount.tmpjob) }}</span
            ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
          </b-form-checkbox>
        </div>
      </template>
      <div class="mb-4">
        <filter-section-title :title-text="translations[10130]" />
        <b-form-select
          v-model="timeFactor"
          :options="optionsTimeFactor"
          size="sm"
          @change="search"
        ></b-form-select>
      </div>
<!--      <filters-auth-alert v-if="!isAuth && !isHintDisabled" />-->
      <div class="bg-light bottom-0 mt-auto position-sticky py-3 z-3">
        <b-button @click="hide" variant="primary" size="sm" class="w-100">{{ jobsCount }} {{ translations[13632] }}</b-button>
      </div>
    </template>
  </core-sidebar>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { Vue, Component, Prop } from 'vue-property-decorator';
// eslint-disable-next-line import/named
import { ICountType, CountType, JobType } from '@/types/ProfessionType';
import FiltersAuthAlert from '@/components/FilterSidebar/FiltersAuthAlert.vue';
import FilterSectionTitle from '@/components/FilterSidebar/FilterSectionTitle.vue';
import SelectProfession from '@/components/Widget/SelectProfession.vue';
import SelectProfessionUpdate from '@/components/Widget/SelectProfessionUpdate.vue';
import SelectLocation from '@/components/Widget/SelectLocation.vue';
import { ProfessionModule } from '@/store/modules/profession';
import Multiselect from 'vue-multiselect';
import { FederalState } from '@/api/Profession';
import SelectLocationRadius from '@/components/Widget/SelectLocationRadius.vue';
import { groupCurses, groupLocationCountryFilter } from '@/config/configuration';
import JobsFilterKleCountMixin from '@/mixins/JobsFilterKleCountMixin';
import LocationCountryFilter from '@/components/FilterSidebar/LocationCountryFilter.vue';

@Component({
  mixins: [JobsFilterKleCountMixin],
  components: {
    SelectLocationRadius,
    SelectProfession,
    SelectLocation,
    FilterSectionTitle,
    SelectProfessionUpdate,
    FiltersAuthAlert,
    Multiselect,
    LocationCountryFilter,
  },
})
export default class JobsFilter extends Vue {
  @Prop({ default: false }) private isWelcome!: boolean;

  tempSearchProfession = null;

  tempSearchLocation = null;

  tempSearchText = null as any;

  tempSearchFullTime = null as any;

  tempSearchPartTime = null as any;

  tempSearchPractice = null as any;

  tempSearchPraktikum = null as any;

  tempSearchSkillLevel1: any;

  tempSearchSkillLevel2: any;

  tempSearchSkillLevel3: any;

  tempSearchClusterTag: any;

  loadingEmploymentCount = false;

  loadingSkillCount = false;

  loadingArbeitgeberartCount = false;

  loadingStellenherkunftCount = false;

  loadingLocationCount = false;

  getKleCountsApi!: () => void;

  tempSearchRadius = null as any;

  tempEmailStatus = null as any;

  tempPartnerJobsOnly: any = null;

  tempOtherJobs: any = null;

  tempAmsjob: any = null;

  tempWorkjob: any = null;

  tempSpecialjob: any = null;

  tempMinijob: any = null;

  tempDejob: any = null;

  tempRecruit: any = null;

  tempTmpjob: any = null;

  get jobType() {
    return ProfessionModule.jobType;
  }

  get isJobMap() {
    return this.jobType === JobType.map;
  }

  get isCurses() {
    return groupCurses(this.sid);
  }

  get jobsCount() {
    const count = ProfessionModule.jobs.amt;
    return count === undefined ? AppModule.setting?.all_count : count;
  }

  get employmentCount(): ICountType {
    return ProfessionModule.employmentCount;
  }

  get urlFilterParams() {
    return ProfessionModule.urlFilter;
  }

  get federalStateItems(): FederalState[] | null {
    return ProfessionModule.filterFederalStateItems;
  }

  get translations() {
    return AppModule.translation;
  }

  get isAuth() {
    return UserModule.isUserAuth;
  }

  get sid() {
    return AppModule.sid;
  }

  get isJnjts() {
    return this.sid === 'jnjts' || this.sid === 'jnjtseu' || this.sid === 'jnjtsat';
  }

  get isLocationCountryFilter() {
    return groupLocationCountryFilter(this.sid);
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get isHintDisabled() {
    return !!AppModule.setting.job_search_hint_disable;
  }

  get isFederalStateFilterVisible() {
    return !AppModule.settingPortal.job_search_filters_settings?.federal_state?.disable;
  }

  get clusters(): any[] {
    const counts: any = AppModule.jobCountPortal.clusters;
    return AppModule.settingPortal.clusters.map((v: any) => ({
      id: v.id,
      name: `${v.name} (${this.localeString(counts.find((x: any) => x.id === v.id)?.count || 0)})`,
    }));
  }

  // search professions
  get selectProfession() {
    const raw = ProfessionModule.searchJobProfession;
    this.tempSearchProfession = raw;
    if (!raw || !Array.isArray(raw)) return raw;
    return raw.map((v: any) => ({ ...v, name: v.name || v.title }));
  }

  set selectProfession(value: any) {
    this.tempSearchProfession = value;
    ProfessionModule.SetSearchJobProfession(value);
    const tagsForTitle = value?.map((v: any) => ({ id: v.id, title: v.title ?? v.name, count: v.count }));
    ProfessionModule.SetSearchJobProfessionTitle(tagsForTitle ?? null);
    const professionIds = (value || [])
      .flatMap((v: any) => String(v?.id ?? '')
        .split('~')
        .flatMap((part: string) => part.split(',')))
      .map((id: string) => id.trim())
      .filter((id: string) => id.length > 0)
      .join(',');
    ProfessionModule.SetSearch({ obj: 'profession_id', value: professionIds || null });
  }
  // search professions

  // search locations
  get selectLocation() {
    this.tempSearchLocation = ProfessionModule.searchJobLocation;
    return ProfessionModule.searchJobLocation;
  }

  set selectLocation(value: any) {
    this.tempSearchLocation = value;
    ProfessionModule.SetSearchJobLocation(value);
    ProfessionModule.SetSearch({ obj: 'location_id', value: value?.id || null });
  }
  // search locations

  // full-text search
  get searchText() {
    // added tag Text
    this.tempSearchText = ProfessionModule.jobSearch.q;
    // end
    return ProfessionModule.jobSearch.q;
  }

  set searchText(value) {
    // added tag State
    this.tempSearchText = value;
    // end
    ProfessionModule.SetSearch({ obj: 'q', value });
  }
  // full-text search

  // radius search
  get radius() {
    this.tempSearchRadius = ProfessionModule.jobSearch.radius;
    return ProfessionModule.jobSearch.radius;
  }

  set radius(value) {
    this.tempSearchRadius = value;
    ProfessionModule.SetSearch({ obj: 'radius', value });
  }
  // full-text search

  // time_factor (опубліковано за період)
  get optionsTimeFactor() {
    return [
      { value: 0, text: this.translations[10155] },
      { value: 2, text: this.translations[10132] },
      { value: 7, text: this.translations[10133] },
      { value: 14, text: this.translations[10134] },
      { value: 30, text: this.translations[10135] },
      { value: 120, text: this.translations[10136] },
    ];
  }

  get timeFactor() {
    return ProfessionModule.jobFilter.time_factor;
  }

  set timeFactor(value: number) {
    ProfessionModule.SetFilter({ obj: 'time_factor', value: Number(value) });
    ProfessionModule.SetSearchTags({ tag: 'timeFactorTag', value: Number(value) !== 0 });
  }
  // time_factor

  // full-text search mode
  get searchTextType() {
    return ProfessionModule.jobSearch.qmode;
  }

  set searchTextType(value) {
    ProfessionModule.SetSearch({ obj: 'qmode', value });
  }

  get searchTextTypeOptions() {
    return [
      {
        value: 2,
        text: this.translations[10437],
      },
      {
        value: 1,
        text: this.translations[10436],
      },
    ];
  }
  // full-text search mode

  // search full-time jobs
  get checkboxFullTime() {
    if (ProfessionModule.searchTags.fullTimeTag === 1) {
      this.tempSearchFullTime = ProfessionModule.jobFilter.fulltime;
    } else {
      this.tempSearchFullTime = !ProfessionModule.jobFilter.fulltime;
    }
    return !ProfessionModule.jobFilter.fulltime;
  }

  set checkboxFullTime(value: any) {
    this.tempSearchFullTime = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'fulltime', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'fullTimeTag', value: false });
  }
  // search full-time jobs

  // search part-time jobs
  get checkboxPartTime() {
    if (ProfessionModule.searchTags.partTimeTag === 1) {
      this.tempSearchPartTime = ProfessionModule.jobFilter.parttime;
    } else {
      this.tempSearchPartTime = !ProfessionModule.jobFilter.parttime;
    }
    return !ProfessionModule.jobFilter.parttime;
  }

  set checkboxPartTime(value) {
    this.tempSearchPartTime = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'parttime', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'partTimeTag', value: false });
  }
  // search part-time jobs

  // search internships jobs
  get checkboxPractice() {
    if (ProfessionModule.searchTags.practiceTag === 1) {
      this.tempSearchPractice = ProfessionModule.jobFilter.edujob;
    } else {
      this.tempSearchPractice = !ProfessionModule.jobFilter.edujob;
    }
    return !ProfessionModule.jobFilter.edujob;
  }

  set checkboxPractice(value) {
    this.tempSearchPractice = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'edujob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'practiceTag', value: false });
  }
  // search internships jobs

  // search praktikum
  get checkboxPraktikum() {
    if (ProfessionModule.searchTags.praktikumTag === 1) {
      this.tempSearchPraktikum = ProfessionModule.jobFilter.praktikum;
    } else {
      this.tempSearchPraktikum = !ProfessionModule.jobFilter.praktikum;
    }
    return !ProfessionModule.jobFilter.praktikum;
  }

  set checkboxPraktikum(value) {
    this.tempSearchPraktikum = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'praktikum', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'praktikumTag', value: false });
  }
  // search praktikum

  // search skill level 1
  get checkboxSkillLevel1() {
    if (ProfessionModule.searchTags.skillLevel1Tag === 1) {
      this.tempSearchSkillLevel1 = ProfessionModule.jobFilter.skill_level1;
    } else {
      this.tempSearchSkillLevel1 = !ProfessionModule.jobFilter.skill_level1;
    }
    return !ProfessionModule.jobFilter.skill_level1;
  }

  set checkboxSkillLevel1(value) {
    this.tempSearchSkillLevel1 = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'skill_level1', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'skillLevel1Tag', value: false });
  }
  // search skill level 1

  // search skill level 2
  get checkboxSkillLevel2() {
    if (ProfessionModule.searchTags.skillLevel2Tag === 1) {
      this.tempSearchSkillLevel2 = ProfessionModule.jobFilter.skill_level2;
    } else {
      this.tempSearchSkillLevel2 = !ProfessionModule.jobFilter.skill_level2;
    }
    return !ProfessionModule.jobFilter.skill_level2;
  }

  set checkboxSkillLevel2(value) {
    this.tempSearchSkillLevel2 = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'skill_level2', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'skillLevel2Tag', value: false });
  }
  // search skill level 2

  // search skill level 3
  get checkboxSkillLevel3() {
    if (ProfessionModule.searchTags.skillLevel3Tag === 1) {
      this.tempSearchSkillLevel3 = ProfessionModule.jobFilter.skill_level3;
    } else {
      this.tempSearchSkillLevel3 = !ProfessionModule.jobFilter.skill_level3;
    }
    return !ProfessionModule.jobFilter.skill_level3;
  }

  set checkboxSkillLevel3(value) {
    this.tempSearchSkillLevel3 = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'skill_level3', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'skillLevel3Tag', value: false });
  }
  // search skill level 3

  get cluster() {
    const clusterStore = ProfessionModule.jobFilter.cluster_id;
    this.tempSearchClusterTag = ProfessionModule.jobFilter.cluster_id;
    return clusterStore ? [clusterStore] : [];
  }

  set cluster(value: any) {
    const param = value[value.length - 1] || 0;
    ProfessionModule.SetFilter({ obj: 'cluster_id', value: param });
    ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: param });
  }

  // search state
  get selectedState() {
    return ProfessionModule.selectedFederalStateItems;
  }

  set selectedState(value) {
    ProfessionModule.SetSelectedFederalStates(value);
  }
  // search state

  get optionsLand() {
    return [
      { value: null, text: this.translations[13237] },
      { value: 0, text: `- ${this.translations[13608]} (123)` },
      { value: 1, text: `- ${this.translations[13609]} (123)` },
      { value: 2, text: `- ${this.translations[13610]} (123)` },
      { value: 3, text: `- ${this.translations[13611]} (123)` },
      { value: 4, text: `- ${this.translations[13612]} (123)` },
      { value: 5, text: `- ${this.translations[13613]} (123)` },
      { value: 5, text: `- ${this.translations[13614]} (123)` },
      { value: 5, text: `- ${this.translations[13615]} (123)` },
      { value: 5, text: `- ${this.translations[13616]} (123)` },
      { value: 5, text: `- ${this.translations[2013]} (123)` },
    ];
  }

  // radius search
  get emailStatus() {
    // const email = ProfessionModule.jobFilter.email_contact;
    this.tempEmailStatus = !!ProfessionModule.jobFilter.email_contact;
    return !!ProfessionModule.jobFilter.email_contact;
  }

  set emailStatus(value) {
    this.tempEmailStatus = Number(value);
    ProfessionModule.SetFilter({ obj: 'email_contact', value: Number(value) });
  }

  // Чекбокси Deutschland/Netherlands disabled тільки коли обрано реальну локацію з селекта (не 1206/1227)
  get isLocationFromDropdown() {
    const id = ProfessionModule.jobSearch.location_id;
    if (!id) return false;
    return +id !== 1206 && +id !== 1227;
  }

  // Location: Deutschland / Niederlanden — зворотна логіка: ON = не додаємо в location_id, OFF = додаємо цей id. Один клік перемикає (той що тиснули — OFF, інший — ON).
  get checkboxLocationGermany() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1206;
  }

  get checkboxLocationNetherlands() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1227;
  }

  onLocationGermanyToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationGermany;
    const newLocation = currentlyOn ? { id: 1227, name: this.translations[15919] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.search());
  }

  onLocationNetherlandsToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationNetherlands;
    const newLocation = currentlyOn ? { id: 1206, name: this.translations[15918] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.search());
  }

  // Нові фільтри (Stellenherkunft, Umfang, Arbeitgeberart) — та сама логіка з перевіркою tag === 1
  get checkboxPartnerJobsOnly() {
    if (ProfessionModule.searchTags.partnerJobsOnlyTag === 1) {
      this.tempPartnerJobsOnly = ProfessionModule.jobFilter.partner_jobs_only;
    } else {
      this.tempPartnerJobsOnly = !ProfessionModule.jobFilter.partner_jobs_only;
    }
    return !ProfessionModule.jobFilter.partner_jobs_only;
  }

  set checkboxPartnerJobsOnly(value) {
    this.tempPartnerJobsOnly = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'partner_jobs_only', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'partnerJobsOnlyTag', value: false });
  }

  get checkboxOtherJobs() {
    if (ProfessionModule.searchTags.otherJobsTag === 1) {
      this.tempOtherJobs = ProfessionModule.jobFilter.other_jobs;
    } else {
      this.tempOtherJobs = !ProfessionModule.jobFilter.other_jobs;
    }
    return !ProfessionModule.jobFilter.other_jobs;
  }

  set checkboxOtherJobs(value) {
    this.tempOtherJobs = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'other_jobs', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'otherJobsTag', value: false });
  }

  get checkboxAmsjob() {
    if (ProfessionModule.searchTags.amsjobTag === 1) {
      this.tempAmsjob = ProfessionModule.jobFilter.amsjob;
    } else {
      this.tempAmsjob = !ProfessionModule.jobFilter.amsjob;
    }
    return !ProfessionModule.jobFilter.amsjob;
  }

  set checkboxAmsjob(value) {
    this.tempAmsjob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'amsjob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'amsjobTag', value: false });
  }

  get checkboxWorkjob() {
    if (ProfessionModule.searchTags.workjobTag === 1) {
      this.tempWorkjob = ProfessionModule.jobFilter.workjob;
    } else {
      this.tempWorkjob = !ProfessionModule.jobFilter.workjob;
    }
    return !ProfessionModule.jobFilter.workjob;
  }

  set checkboxWorkjob(value) {
    this.tempWorkjob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'workjob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'workjobTag', value: false });
  }

  get checkboxSpecialjob() {
    if (ProfessionModule.searchTags.specialjobTag === 1) {
      this.tempSpecialjob = ProfessionModule.jobFilter.specialjob;
    } else {
      this.tempSpecialjob = !ProfessionModule.jobFilter.specialjob;
    }
    return !ProfessionModule.jobFilter.specialjob;
  }

  set checkboxSpecialjob(value) {
    this.tempSpecialjob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'specialjob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'specialjobTag', value: false });
  }

  get checkboxMinijob() {
    if (ProfessionModule.searchTags.minijobTag === 1) {
      this.tempMinijob = ProfessionModule.jobFilter.minijob;
    } else {
      this.tempMinijob = !ProfessionModule.jobFilter.minijob;
    }
    return !ProfessionModule.jobFilter.minijob;
  }

  set checkboxMinijob(value) {
    this.tempMinijob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'minijob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'minijobTag', value: false });
  }

  get checkboxDejob() {
    if (ProfessionModule.searchTags.dejobTag === 1) {
      this.tempDejob = ProfessionModule.jobFilter.dejob;
    } else {
      this.tempDejob = !ProfessionModule.jobFilter.dejob;
    }
    return !ProfessionModule.jobFilter.dejob;
  }

  set checkboxDejob(value) {
    this.tempDejob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'dejob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'dejobTag', value: false });
  }

  get checkboxRecruit() {
    if (ProfessionModule.searchTags.recruitTag === 1) {
      this.tempRecruit = ProfessionModule.jobFilter.recruit;
    } else {
      this.tempRecruit = !ProfessionModule.jobFilter.recruit;
    }
    return !ProfessionModule.jobFilter.recruit;
  }

  set checkboxRecruit(value) {
    this.tempRecruit = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'recruit', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'recruitTag', value: false });
  }

  get checkboxTmpjob() {
    if (ProfessionModule.searchTags.tmpjobTag === 1) {
      this.tempTmpjob = ProfessionModule.jobFilter.tmpjob;
    } else {
      this.tempTmpjob = !ProfessionModule.jobFilter.tmpjob;
    }
    return !ProfessionModule.jobFilter.tmpjob;
  }

  set checkboxTmpjob(value) {
    this.tempTmpjob = Boolean(!value);
    ProfessionModule.SetFilter({ obj: 'tmpjob', value: Number(!value) });
    ProfessionModule.SetSearchTags({ tag: 'tmpjobTag', value: false });
  }

  localeString(payload: number) {
    return payload ? payload.toLocaleString() : 0;
  }

  isSearchTriggered = false;

  get getUrlParams() {
    return !!this.$route.query?.filters;
  }

  handleHideEvent() {
    if (this.isSearchTriggered) {
      this.setUrlParams();
      this.isSearchTriggered = false;
    }
    if (!this.getUrlParams) {
      this.setUrlParams();
      AppModule.SetVisibleJobs(true);
    }
  }

  setUrlParams() {
    const currentQueryParams = { ...this.$route.query };
    currentQueryParams.filters = this.urlFilterParams;
    this.$router.replace({ query: currentQueryParams }).catch(() => {});
  }

  search() {
    this.isSearchTriggered = true;
    // this.getEmploymentCountApi();
    AppModule.SetVisibleJobs(false);
    AppModule.SetVisibleClusterJobs(false);
    AppModule.SetVisibleMap(false);
    this.$nextTick(() => {
      // search tags
      ProfessionModule.SetSearchJobProfessionTitle(this.tempSearchProfession);
      ProfessionModule.SetSearchJobLocationTitle(this.tempSearchLocation);
      // search filter tags
      ProfessionModule.SetSearchTags({ tag: 'textTag', value: this.tempSearchText });
      ProfessionModule.SetSearchTags({ tag: 'fullTimeTag', value: this.tempSearchFullTime });
      ProfessionModule.SetSearchTags({ tag: 'partTimeTag', value: this.tempSearchPartTime });
      ProfessionModule.SetSearchTags({ tag: 'practiceTag', value: this.tempSearchPractice });
      ProfessionModule.SetSearchTags({ tag: 'praktikumTag', value: this.tempSearchPraktikum });
      ProfessionModule.SetSearchTags({ tag: 'skillLevel1Tag', value: this.tempSearchSkillLevel1 });
      ProfessionModule.SetSearchTags({ tag: 'skillLevel2Tag', value: this.tempSearchSkillLevel2 });
      ProfessionModule.SetSearchTags({ tag: 'skillLevel3Tag', value: this.tempSearchSkillLevel3 });
      ProfessionModule.SetSearchTags({ tag: 'radius', value: this.tempSearchRadius });
      ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: this.tempSearchClusterTag });
      ProfessionModule.SetSearchTags({ tag: 'emailContact', value: this.tempEmailStatus });
      ProfessionModule.SetSearchTags({ tag: 'partnerJobsOnlyTag', value: this.tempPartnerJobsOnly });
      ProfessionModule.SetSearchTags({ tag: 'otherJobsTag', value: this.tempOtherJobs });
      ProfessionModule.SetSearchTags({ tag: 'amsjobTag', value: this.tempAmsjob });
      ProfessionModule.SetSearchTags({ tag: 'workjobTag', value: this.tempWorkjob });
      ProfessionModule.SetSearchTags({ tag: 'specialjobTag', value: this.tempSpecialjob });
      ProfessionModule.SetSearchTags({ tag: 'minijobTag', value: this.tempMinijob });
      ProfessionModule.SetSearchTags({ tag: 'dejobTag', value: this.tempDejob });
      ProfessionModule.SetSearchTags({ tag: 'recruitTag', value: this.tempRecruit });
      ProfessionModule.SetSearchTags({ tag: 'tmpjobTag', value: this.tempTmpjob });
      ProfessionModule.SetSearchTags({ tag: 'timeFactorTag', value: ProfessionModule.jobFilter.time_factor !== 0 });
      // this.setUrlParams();
      AppModule.SetVisibleJobs(true);
      if (this.isWelcome) {
        AppModule.SET_WELCOME(true);
        this.$router.push({
          name: 'Jobs',
          query: { lang: AppModule.language },
        });
      }
    });
  }

  getEmploymentCountApi() {
    const defaultCountParams = {
      sid: this.languageSid,
      count: 1,
    };
    this.$nextTick(() => {
      if (this.sid === 'kle') {
        this.getKleCountsApi();
      } else if (
        this.isSearchTriggered
        || this.employmentCount.fulltime == null
        || this.employmentCount.parttime == null
        || this.employmentCount.edujob == null
        || (this.isJnjts && this.employmentCount.praktikum == null)
      ) {
        // Для JNJTS у блоці employment є додатковий фільтр praktikum.
        this.loadingEmploymentCount = true;
        const load1 = ProfessionModule.GetJobsCount({
          filter: CountType.fulltime,
          params: {
            ...defaultCountParams,
            edujob: 1,
            parttime: 1,
            ...(this.isJnjts ? { praktikum: 1 } : {}),
          },
        });
        const load2 = ProfessionModule.GetJobsCount({
          filter: CountType.parttime,
          params: {
            ...defaultCountParams,
            edujob: 1,
            fulltime: 1,
            ...(this.isJnjts ? { praktikum: 1 } : {}),
          },
        });
        const load3 = ProfessionModule.GetJobsCount({
          filter: CountType.edujob,
          params: {
            ...defaultCountParams,
            fulltime: 1,
            parttime: 1,
            ...(this.isJnjts ? { praktikum: 1 } : {}),
          },
        });
        const employmentLoads = [load1, load2, load3];
        if (this.isJnjts) {
          const load4 = ProfessionModule.GetJobsCount({
            filter: CountType.praktikum,
            params: {
              ...defaultCountParams,
              fulltime: 1,
              parttime: 1,
              edujob: 1,
            },
          });
          employmentLoads.push(load4);
        }

        Promise.all(employmentLoads)
          .finally(() => {
            this.loadingEmploymentCount = false;
          });
      }
      if (this.isSearchTriggered || (this.employmentCount.skill_level1 == null || this.employmentCount.skill_level2 == null || this.employmentCount.skill_level3 == null)) {
        this.loadingSkillCount = true;
        const load1 = ProfessionModule.GetJobsCount({
          filter: CountType.skill_level1,
          params: {
            ...defaultCountParams,
            skill_level2: 1,
            skill_level3: 1,
          },
        });
        const load2 = ProfessionModule.GetJobsCount({
          filter: CountType.skill_level2,
          params: {
            ...defaultCountParams,
            skill_level3: 1,
          },
        });
        const load3 = ProfessionModule.GetJobsCount({
          filter: CountType.skill_level3,
          params: {
            ...defaultCountParams,
            skill_level1: 1,
            skill_level2: 1,
          },
        });
        Promise.all([load1, load2, load3])
          .finally(() => {
            this.loadingSkillCount = false;
          });
      }
      if (this.isLocationCountryFilter && (this.isSearchTriggered || this.employmentCount.location_germany == null || this.employmentCount.location_netherlands == null)) {
        this.loadingLocationCount = true;
        const locLoad1 = ProfessionModule.GetJobsCount({
          filter: CountType.location_germany,
          params: {
            ...defaultCountParams,
            location_id: 1206,
            jobnews_type: 1,
          },
        });
        const locLoad2 = ProfessionModule.GetJobsCount({
          filter: CountType.location_netherlands,
          params: {
            ...defaultCountParams,
            location_id: 1227,
            jobnews_type: 1,
          },
        });
        Promise.all([locLoad1, locLoad2]).finally(() => {
          this.loadingLocationCount = false;
        });
      }
    });
  }

  getStateFilterApi() {
    if (!this.federalStateItems?.length) {
      ProfessionModule.GetFederalStateItems({
        sid: this.languageSid,
      });
    }
    this.getEmploymentCountApi();
  }
}
</script>
